export default __webpack_public_path__ + "static/media/image3.7edf1e23.jpg";